import React from "react"
import TextField from "canvas-core-react/lib/TextField"
import { onlyNumberFormatInput } from "../../utils/utils"


const InputAmount = props => {
	const { changeItem, error_input_amount, amount, max_amount_range, min_amount_range } = props
	const amount_range = `El monto mínimo a invertir es $${min_amount_range}`

	const inputError = {
		label: "El monto ingresado es menor al mínimo requerido",
		messages: ["El monto ingresado es menor al mínimo requerido"]
	}
	const inputErrorMax = {
		label: "El monto ingresado excede el máximo permitido",
		messages: ["El monto ingresado excede el máximo permitido"]
	}

	const handleOnChange = e => {
		const inputOfUser = e.target.value.replace(/[^0-9]/g, "")
		const onlyNumberRegularExpression = /^[0-9]*$/
		const validatorInput = onlyNumberRegularExpression.test(inputOfUser) && parseInt(inputOfUser) > 0 && parseInt(inputOfUser) >= parseInt(min_amount_range) && parseInt(inputOfUser) <= parseInt(max_amount_range) 

		if (inputOfUser === "0" || inputOfUser === "") {
			changeItem({ error_input_amount: "", amount: inputOfUser })
		}
		if (parseInt(inputOfUser) > parseInt(max_amount_range)) {
			changeItem({ error_input_amount: inputErrorMax, amount: inputOfUser })
		}
		else if (validatorInput) {
			changeItem({ error_input_amount: null, amount: inputOfUser })
		} else {
			changeItem({ error_input_amount: inputError, amount: inputOfUser })
		}

	}

	return (
		<TextField
			id="dataEntry_amount"
			data-testid="dataEntry_amount"
			type="text"
			name="amount"
			label="Monto a invertir"
			maxLength={14}
			placeholder="Ingresa un monto"
			supplementaryText={amount_range}
			onChange={handleOnChange}
			error={error_input_amount}
			value={onlyNumberFormatInput(amount)}
		/>
	)
}

export default InputAmount